import DownloadProgressDrawer from './DownloadProgressDrawer';
import UploadProgressDrawer from './UploadProgressDrawer';

const TransferProgressDrawers = () => {
  return (
    <div className="fixed bottom-0 right-10 z-50">
      <div className="flex flex-col">
        <DownloadProgressDrawer />
        <UploadProgressDrawer />
      </div>
    </div>
  );
};
export default TransferProgressDrawers;
